// extracted by mini-css-extract-plugin
export default {"ActionWrapper":"DataTable_ActionWrapper__oVbTI","lastRow":"DataTable_lastRow__yrjCf"};